import styled from 'styled-components'

export const Filters = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.bg4};
  border-radius: ${({ theme }) => theme.BORDER_RADIUS.smallest};
  display: inline-block;
  margin-top: 1rem;
  overflow: auto;
`

export const FilterButton = styled.button<{ active?: boolean }>`
  appearance: none;
  background-color: ${({ theme, active }) => (active ? theme.primary1 : theme.bg4)};
  border: none;
  border-radius: ${({ theme }) => theme.BORDER_RADIUS.smallest};
  box-shadow: none;
  color: ${({ theme }) => theme.text1};
  cursor: pointer;
  font-weight: 500;
  outline: none;
  padding: 0.5rem 1rem;
  white-space: nowrap;
`
